
<template>
  <div>
    <v-menu
      ref="menu"
      v-model="menu"
      :close-on-content-click="false"
      :return-value.sync="date"
      transition="scale-transition"
      offset-y
      min-width="auto"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-text-field v-bind="attrs" v-on="on" :value="$dayjs(date).format('DD/MM/YYYY')" label="Escolha o dia" prepend-icon="mdi-calendar" readonly :rules="required"></v-text-field>
      </template>
      <v-date-picker v-model="date" no-title scrollable >
        <v-spacer></v-spacer>
        <v-btn text color="primary" @click="menu = false" >
          Cancelar
        </v-btn>
        <v-btn text color="primary" @click="saveDate()" >
          OK
        </v-btn>
      </v-date-picker>
    </v-menu>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex';
import validations from '@/mixins/validations';

export default {
  name: 'NewExecutionDate',
  mixins: [ validations ],
  data() {
    return {
      menu: false,
      date: new Date().toISOString().substring(0,10),
      today: new Date().toISOString().substring(0,10),
    }
  },
  mounted () {
    this.updateDateExec(new Date().toISOString().substring(0,10));
  },
  methods: {
    saveDate() {
      this.$refs.menu.save(this.date)
      // this.updateDateExec()
    },
    ...mapActions({
      updateDateExec: 'Execution/updateDateExec'
    })
  },
  computed: {
    ...mapState({
      execution_date: state => state.Execution.execution_date
    })
  },
  watch: {
    date(nv,ov) {
      if (nv){
        if (this.$dayjs(this.date) >= this.$dayjs(this.today)) {
          this.updateDateExec(this.date)
          console.log('if')
        } else {
          console.log('else')
          this.date = new Date().toISOString().substring(0,10)
        }
      }
    }
  },
}
</script>

<style scoped>

</style>